const id = 49015766;

export const ymHit = (url: string, options?: any) => {
    return window?.['ym']?.(id, 'hit', url, options);
}

/**
 * site.worksheet.created
 */
export const ymReachGoal = (target: string, payload?: any) => {
    window?.['ym']?.(id, 'reachGoal', target, payload);
}
